<template>
    <div class="rounded shadow-lg modal-content-container">
        <div class="pt-3 px-3">
            <div>
                <h6><strong>Current Visit Rate </strong></h6>
            </div>
        </div>
        <hr class="mb-2" />
        <div class="px-2">
            <h6>Customize the rate for this visit below</h6>
            <form role="form">
                <div v-if="payRates && payRates.length">
                    <div class="mb-3 row" v-for="rate of payRates" :key="rate.id">
                        <span class="me-3 col-2">{{ rate.Label }}</span>
                        <div class="rate-input col-8 w-75">
                            <div class="input-group input-group-sm">
                                <div class="input-group-prepend">
                                    <span
                                        v-if="isBelowMinRate(Rate, MinRate)"
                                        class="input-group-text bg-danger text-white"
                                        >!</span
                                    >
                                    <span v-else class="input-group-text rate-icon bg-success">$</span>
                                </div>
                                <input type="number" v-model="rate.Rate" class="form-control" />
                            </div>
                            <div v-if="isBelowMinRate(Rate, MinRate)" class="text-end text-danger">
                                Min: {{ rate.MinRate }}
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="mt-0 d-flex pb-2 px-3 justify-content-center">
                <button
                    :disabled="!areRatesAboveMin"
                    @click="savePayRates"
                    type="button"
                    class="btn btn-xs me-2 btn-outline-primary"
                >
                    Save
                </button>
                <button @click="cancel()" type="button" class="btn btn-xs btn-primary">Cancel</button>
            </div>
        </div>
    </div>
</template>

<script lang="ts" src="./PayrateModal.ts"></script>
